import React from "react";

export const Description = ({ desc }) => (
  <p className="experience__description">{desc}</p>
);
